import iconsCloud from '../data/icons.json'

const ErrorPage = () => {
  return (
    <div className="container">
        <img src={iconsCloud[0].errorPage} alt="" />
    </div>
  )
}

export default ErrorPage
